import {Lightbox} from '../../classes/Lightbox';

export const initSpotCards = () => {
	const spotCards = document.querySelector( 'section.cds2-spot-complex-cards:not([data-size="s"])' );

	if ( !spotCards )
	{
		return;
	}

	spotCards.addEventListener( 'click', ( evt ) => {
		if ( window.innerWidth > 1023 || !evt.target.closest( 'section.cds2-spot-complex-cards:not([data-size="s"]) > ul > li' ) )
		{
			return;
		}

		evt.preventDefault();
		Lightbox.open( evt.target.closest( 'section.cds2-spot-complex-cards:not([data-size="s"]) > ul > li > a' ), null, 'tooltip' );
	} );
};